import * as React from "react";
import * as R from "ramda";
import { Form } from "react-final-form";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { DotLoader } from "react-spinners";
import { Tarea } from "../modelo/Tarea";
import TablaTareas from "./TablaTareas";
import { consultarTareas, reintentarTarea } from "../modulos/bandejaActions";
import TipoIdentificacion from "../../general/componentes/TipoIdentificacion";
import NumericInput from "../../general/componentes/NumericInput";
import TipoCliente from "../../general/componentes/TipoCliente";
import EstadosTarea from "./EstadosTarea";
import { REQUEST } from "../../../config/ajax-wrapper";
import { Mensaje } from "../../general/componentes/Mensaje";
import { FiltroTarea } from "../modelo/Tarea";
import DatePickerSura from "../../general/componentes/DatePicker";

class BandejaTareas extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            dni: String,
            tipoCliente: String,
            estado: EstadosTarea,
            dniUsuario: String
        };
    }

    render() {
        const { tareas, estado, paginas, tamanoPagina, paginaActual } = this.props;
        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Bandeja Tareas</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Buscar Tareas</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className="form-group">
                                            <Col sm={3}>
                                                <label htmlFor="tipoDocumento">Tipo Documento</label>
                                                <TipoIdentificacion name="tipoDocumento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="documento">Documento</label>
                                                <NumericInput name="documento" placeholder="Ingrese un documento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label>Tipo Cliente</label>
                                                <TipoCliente name="tipoCliente" excluir={["DE","OI"]} />
                                            </Col>
                                            <Col sm={3}>
                                                <label>Estado</label>
                                                <EstadosTarea name={"estado"} />
                                            </Col>
                                        </Row>
                                        <Row className="form-group">
                                            <Col sm={3}>
                                                <label>Fecha Inicio</label>
                                                <DatePickerSura name={"fechaInicio"}/>
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Fin</label>
                                                <DatePickerSura name={"fechaFin"}/>
                                            </Col>
                                            {this.renderCampoIdUsuario()}
                                        </Row>
                                        <Row className="form-group">
                                            <Col smOffset={7} sm={1}>
                                                <button type="button" className="btns btns-link" onClick={form.reset}
                                                    disabled={submitting || pristine}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={1}>
                                                <button type="submit" className="btns btns-primary"
                                                    disabled={submitting || invalid}>
                                                    Consultar
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderTareas(tareas, estado, paginas, tamanoPagina, paginaActual)}
                </Row>
            </div>
        );
    }

    renderTareas(tareas: Array<Tarea>, estado: REQUEST, paginas: number, tamanoPagina: number, paginaActual: number) {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.SUCCESS:
                if (!tareas || !tareas.length) {
                    return (
                        <span>
                            <Mensaje type={"danger"} mensaje={"No hemos encontrado tareas."} />
                        </span>
                    );
                } else {
                    return (
                        <span>
                            <TablaTareas onReintentar={this.reintentar} estado={this.props.estadoReintento}
                                tareas={tareas} filtroTarea={this.filtros()}
                                consultaPaginada={this.consultaPaginada}
                                paginas={paginas} 
                                tamanoPagina={tamanoPagina}
                                paginaActual={paginaActual} />
                        </span>
                    );
                }
            default:
                return false;
        }
    }

    renderCampoIdUsuario() {
        if(this.props.isSuper) {
            return(          
                <Col sm={3}>
                    <label htmlFor="numDocumentoUsuario">Numero documento usuario</label>
                    <NumericInput name="numDocumentoUsuario" />
                </Col>
            );
        }
    }

    filtros(): FiltroTarea {
        return { 
            dni: this.state.dni, 
            tipoCliente: this.state.tipoCliente ,
            dniUsuario: this.state.dniUsuario, 
            isSuper: this.props.isSuper,
            estado: this.state.estado,
            fechaInicio: this.state.fechaInicio,
            fechaFin: this.state.fechaFin,
        };
    }

    consultaPaginada = (filtroTarea: FiltroTarea) => {
        this.props.dispatch(consultarTareas(filtroTarea));
    };

    validate = values => {
        const errors = { documento: undefined, tipoDocumento: undefined, fechaInicio: undefined, fechaFin: undefined };

        if (values.tipoDocumento && !values.documento) {
            errors.documento = "Por favor ingrese un documento";
        }

        if ((!values.tipoDocumento || values.tipoDocumento === "Selecciona...") && values.documento) {
            errors.tipoDocumento = "Por favor seleccione un tipo de documento";
        }

        if (values.fechaInicio && !values.fechaFin) {
            errors.fechaFin = "Por favor selecciona una fecha de fin";
        }

        if (!values.fechaInicio && values.fechaFin) {
            errors.fechaInicio = "Por favor selecciona una fecha de inicio";
        }

        if (values.fechaInicio && values.fechaFin &&
            (values.fechaInicio.isAfter(values.fechaFin))) {
            errors.fechaFin = "La fecha fin no puede ser anterior a la fecha de inicio";
        }

        return errors;
    };

    onSubmit = values => {
        const dni = values.tipoDocumento && values.documento ? (values.tipoDocumento + values.documento) : undefined;
        const tipoCliente = values.tipoCliente ? values.tipoCliente.valueOf() : "";
        const dniUsuarioSuper = values.numDocumentoUsuario ? values.numDocumentoUsuario.valueOf() : "";
        const dniUsuario = this.props.isSuper ? dniUsuarioSuper : this.props.dniLogin;
        const fechaInicio = values.fechaInicio ? values.fechaInicio.valueOf() : "";
        const fechaFin = values.fechaFin ? values.fechaFin.valueOf() : "";
        const estado = values.estado ? values.estado.valueOf() : "";
        

        const filtroTarea: FiltroTarea = {
            dni: dni, tipoCliente: tipoCliente, 
            tamanoPagina: this.props.tamanoPagina,
            paginaActual: 0, 
            dniUsuario: dniUsuario,
            isSuper: this.props.isSuper,
            fechaInicio: fechaInicio,
            fechaFin: fechaFin,
            estado: estado
        };

        this.setState(
            { 
                dni: dni, 
                tipoCliente: tipoCliente, 
                estado: estado, 
                dniUsuario: dniUsuario,
                fechaInicio: fechaInicio,
                fechaFin: fechaFin,
            }
        );

        this.props.dispatch(consultarTareas(filtroTarea));
    };

    reintentar = (identificacion: string, tipoCliente: string) => {
        this.props.dispatch(reintentarTarea(identificacion, tipoCliente, this.props.dniLogin));
    }
}

export default connect((store: any) => {
    return {
        estado: R.pathOr([], ["bandeja", "estado"])(store),
        estadoReintento: R.pathOr([], ["bandeja", "estadoReintento"])(store),
        tareas: R.pathOr([], ["bandeja", "tareas"])(store),
        tamanoPagina: R.pathOr([], ["bandeja", "tamanoPagina"])(store),
        paginaActual: R.pathOr([], ["bandeja", "paginaActual"])(store),
        paginas: R.pathOr([], ["bandeja", "paginas"])(store),
        dniLogin: R.pathOr("", ["inicio", "dniLogin"])(store),
        isSuper: R.pathOr(false, ["inicio", "isSuper"])(store)
    };
})(BandejaTareas);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/bandeja/componentes/BandejaTareas.tsx